import { render, staticRenderFns } from "./publicsetting.vue?vue&type=template&id=6e469312"
import script from "./publicsetting.vue?vue&type=script&lang=js"
export * from "./publicsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports